import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import md5 from "js-md5";
import CryptoJS from 'crypto-js'
const serect = "b85195958cfbd862"

//加密
// export function encrypt(word, serect){ 
function encryptAES(word) {
  const key = CryptoJS.enc.Utf8.parse(serect); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

//解密
// export function decrypt(word, serect){  
function decryptAES(word) {
  const key = CryptoJS.enc.Utf8.parse(serect); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
import {
  Message,
  Loading
} from 'element-ui'

import config from './config'
import router from '../router'
import store from '../store'
let loading;

axios.defaults.timeout = 2000000000 //超时时间
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
//console.log(config)
//判断当前是什么环境切换ip
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = config.dev.DEV_BASE
} else {
  axios.defaults.baseURL = config.pro.PRO_BASE
}
Vue.prototype.default_URL = axios.defaults.baseURL
//console.log(axios.defaults.baseURL)
// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers['x-jy-token'] = localStorage.getItem('token') || ''

    // loading = Loading.service({})
    return config
  },
  error => {
    // loading.close()
    return Promise.reject(error)
  },


)

// //http response 拦截器
axios.interceptors.response.use(

  response => {
    // if (response.data.errCode == 2) {
    //     router.push({
    //         path: "/login",
    //         querry: { redirect: router.currentRoute.fullPath }
    //     })
    // }
    // loading.close()
    return response;
  },
  error => {
    // loading.close()
    if (error.message.includes('timeout')) {
      Message.error('请求超时，稍后再试')
      return Promise.reject(error)
    }
    if (!error.message.includes('x-jy-token')) {
      Message.error('请求超时，稍后再试')
      return Promise.reject(error)
    }

  },

)

// request
export function request(url, method, params = {}, headers = {}, isQS = true, config = {}, intercept = false, allowTokenEfficacy = false) {
  // allowTokenEfficacy 允许令牌失效
  //登录的时候才请求
  if (intercept && !store.state.hasLogin) return new Promise((res, rej) => {})


  // 首先判断是get请求还是post请求
  let data = method.toLocaleLowerCase() == 'get' ? 'params' : 'data';
  //console.log(headers,isQS)
  const timestamp = Date.now()
  const serectToken = {
    'jy-appid': 'jypc',
    'jy-sign': md5(`jy-appid=jypc&jy-device=1&jy-timestamp=${timestamp}&${serect}`),
    'jy-token': encryptAES(`jypc_1_${timestamp}`)
  }
  return axios({
    headers: {
      ...headers,
      ...serectToken
    },
    method,
    url,
    [data]: method.toLocaleLowerCase() == 'get' ? params : isQS ? qs.stringify(params) : params, // 差异点在于data的值,默认处理格式
    ...config
  }).then((res) => {
    if (res.data.responseCode == 'invalidAuthorization') {
      router.push({
        name: 'login'
      })
      store.commit('LOGINOUT')
    } else {
      return Promise.resolve(res.data);

    }
  }).catch((err) => {
    return Promise.reject(err);
  })
}



// WEBPACK FOOTER //
// ./src/utils/http.js